/**
 * Created by liux on 2018/5/10.
 * 将给定的参数正确的添加到 url 中,url 接受任意合法 url，query 接受一个参数对象或者参数字符串
 * @params string string | object
 * @return string
 */
import {realType} from './utils'
export default function(url, query) {
  if(typeof url !== 'string' || !query){
    return url
  }
  if(realType(query) === 'object'){
    var str = '';
    for (let key in query){
      str += `${key}=${query[key]}&`
    }
    query = str.slice(0,-1)
  }
  if(/\?/.test(url.split('#')[0])){
    return url.replace(/\?/,'$&'+query+'&')
  }else {
    return url.replace(/#|$/,'?'+query+'$&')
  }
}